

































































































import {Component, Prop, Vue} from 'vue-property-decorator'
import productModule from '@/store/module/ProductModule';
import {Resource, ResourceType} from "@/model/ThingModel";
import DataSpec, {
  BoolSpec,
  BoolSpecPair,
  BoolValue,
  DataType,
  DoubleSpec,
  EnumSpec,
  FloatSpec,
  IntSpec,
  isBoolType,
  isEnumType,
  isNumberType,
  isTextType,
  NumberSpec,
  TextSpec
} from '@/module/thing/DataSpec';
import ierror from "tools-ts/src/error/InnerError";
import UnitSelect from "@/component/Thing/unit-select.vue";
import {Container} from "typescript-ioc";
import UnitApi from "@/module/thing/UnitApi";
import Unit from "@/model/Unit";

@Component({
  components: {UnitSelect},
})
export default class DataSpecsFormItems extends Vue {

  @Prop() private dataType!: DataType
  @Prop() private dataSpecs!: Array<DataSpec>

  private resources: Array<Resource> = []

  private productModule = productModule

  private dataTypeOptions = [
    {value: DataType.INT, label: 'int'},
    {value: DataType.FLOAT, label: 'float'},
    {value: DataType.DOUBLE, label: 'double'},
    {value: DataType.ENUM, label: 'enum'},
    {value: DataType.BOOL, label: 'bool'},
    {value: DataType.TEXT, label: 'text'},
  ]

  private boolNamePlaceHolder(spec: BoolSpec) {
    let desc!: string
    switch (spec.value) {
      case BoolValue.FALSE:
        desc = 'close'
        break
      case BoolValue.TRUE:
        desc = 'open'
        break
      default:
        ierror(`未知布尔值 ${spec.value}`)
    }
    return this.$translate('desc', 'like') + ' ' + this.$translate(desc)
  }

  private ResourceType = ResourceType

  private DataType = DataType

  private getDataType(): DataType {
    return this.dataType
  }

  isNumberType() {
    return isNumberType(this.getDataType())
  }

  isTextType() {
    return isTextType(this.getDataType())
  }

  isBoolType() {
    return isBoolType(this.getDataType())
  }

  isEnumType() {
    return isEnumType(this.getDataType())
  }

  private getDataSpecs(): Array<DataSpec> {
    return this.dataSpecs
  }

  private getNumberSpec(): NumberSpec {
    return this.getDataSpecs()[0] as NumberSpec
  }

  private getTextSpec(): TextSpec {
    return this.getDataSpecs()[0] as TextSpec
  }

  private getBoolSpecs(): Array<BoolSpec> {
    return this.dataSpecs as unknown as Array<BoolSpec>
  }

  private getEnumSpecs(): Array<EnumSpec> {
    return this.dataSpecs as unknown as Array<EnumSpec>
  }

  private changeDataType(dataType: DataType) {
    this._resetDataSpecs(dataType)
  }

  resetDataSpecs() {
    this._resetDataSpecs(this.dataType)
  }

  private _resetDataSpecs(dataType: DataType) {
    this.$emit('update:dataType', dataType)
    switch (dataType) {
      case DataType.INT:
        this.setDataSpecs(new IntSpec())
        break
      case DataType.FLOAT:
        this.setDataSpecs(new FloatSpec())
        break
      case DataType.DOUBLE:
        this.setDataSpecs(new DoubleSpec())
        break
      case DataType.BOOL:
        this.setDataSpecs(...(new BoolSpecPair()))
        break
      case DataType.ENUM:
        this.setDataSpecs(new EnumSpec())
        break
      case DataType.TEXT:
        this.setDataSpecs(new TextSpec())
        break
      default:
        ierror(`未处理数据类型: ${dataType}`)
    }
  }

  private setDataSpecs(...dataSpecs: Array<DataSpec>) {
    this.$emit('update:dataSpecs', dataSpecs)
  }

  private addDataSpec(dataSpec: DataSpec) {
    const specs = this.getDataSpecs()
    specs.push(dataSpec)
    this.setDataSpecs(...specs)
  }

  private addEnumItem() {
    this.addDataSpec(new EnumSpec())
  }

  private api = Container.get(UnitApi)

  private units: Array<Unit> = []

  private async created() {
    this.units = await this.api.list()
  }
}
